/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { DefinitionRendererBuilder, FormRendererBuilder, FormRendererConfig } from '../../renderers';
import { FormInput, ListInput, SectionContainer, SelectInput } from './components';
import { BooleanInput } from './components/BooleanInput';
import { FileInput } from './components/FileInput';
import { MultiFileInput } from './components/MultiFileInput';
import { MultiSelectInput } from './components/MultiSelectInput';

const chakraFormConfig: FormRendererConfig = {
  components: {
    Input: FormInput,
    Select: SelectInput,
    Switch: BooleanInput,
    MultiSelect: MultiSelectInput,
    File: FileInput,
    MultiFile: MultiFileInput,
    ListInput,
    SectionContainer,
  },
};

export const ChakraFormRenderer = FormRendererBuilder(chakraFormConfig);
export const ChakraDefinitionRenderer = DefinitionRendererBuilder(chakraFormConfig.components);
